import styled from 'styled-components';

export const BaseLayout = styled.div`
  display: flex;
  padding: 20px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 5px;
  background: ${({ theme }) => theme.palette.common.white};
  overflow: auto;
`;

export const SectionHeader = styled.h1`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 14px;
  font-weight: 500;
  margin: 0;
  margin-bottom: 6px;
`;

export const AlarmRespondersHeader = styled.p`
  color: ${({ theme }) => theme.palette.primary.dark};
  font-size: 20px;
  font-weight: 500;
  line-height: 160%; /* 32px */
  margin: 20px 0;
  letter-spacing: 0.15px;
`;

// common styles for escalations row
export const EscalationContainer = styled.div`
  display: flex;
  flex-direction: row;
  display: flex;
  padding: 20px 16px;
  align-items: center;
  align-self: stretch;
  border-radius: 5px;
  background: ${({ theme }) => theme.palette.grey[50]};
  margin-bottom: 20px;
`;

export const EscalationOrder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 32px;
  color: ${({ theme }) => theme.palette.common.white};
  background-color: ${({ theme }) => theme.palette.grey[400]};
  border-radius: 16px;
  text-align: center;
  font-size: 20px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.14px;
  margin-right: 10px;
`;

export const EscalationCell = styled.div<{ width: string }>`
  display: flex;
  flex-direction: column;
  justify-content: bottom;
  margin-right: 10px;
  width: ${(props) => props.width};
`;

export const CellHeader = styled.p`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 14px;
  font-weight: 500;
  margin: 0;
  margin-bottom: 8px;
`;

export const FieldErrorText = styled.p`
  color: ${({ theme }) => theme.palette.error.main};
  font-size: 12px;
  margin: 4px 0 0;
`;
